// TD Product Refill Upsell — toggle highlight, qty stepper, and add-to-cart.
(function () {
  function initBar(bar) {
    if (bar.dataset.rfInit) return;
    bar.dataset.rfInit = "true";

    const segs = Array.from(bar.querySelectorAll(".rf-seg"));
    const qtyEl = bar.querySelector("[data-rf-qty]");
    const dec = bar.querySelector("[data-rf-dec]");
    const inc = bar.querySelector("[data-rf-inc]");
    const addBtn = bar.querySelector(".rf-add");

    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    segs.forEach((seg) => {
      seg.addEventListener("click", () => {
        if (seg.hasAttribute("disabled")) return;
        segs.forEach((s) => s.classList.remove("hon"));
        seg.classList.add("hon");
      });
    });

    function getQty() {
      return Math.max(1, parseInt(qtyEl.textContent, 10) || 1);
    }
    function setQty(n) {
      qtyEl.textContent = Math.max(1, n);
    }
    if (dec) dec.addEventListener("click", () => setQty(getQty() - 1));
    if (inc) inc.addEventListener("click", () => setQty(getQty() + 1));

    function selectedVariantId() {
      const active = segs.find((s) => s.classList.contains("hon"));
      return (
        (active && active.dataset.variantId) ||
        (addBtn && addBtn.dataset.defaultVariantId) ||
        ""
      );
    }

    if (addBtn) {
      addBtn.addEventListener("click", () => {
        const variantId = selectedVariantId();
        if (!variantId) return; // design-only (no product linked)

        addBtn.setAttribute("disabled", "disabled");

        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", getQty());

        const config =
          typeof fetchConfig === "function"
            ? fetchConfig("javascript")
            : { method: "POST", headers: { Accept: "application/javascript" } };
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        if (cart && typeof cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === "function") {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "td-refill-upsell",
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === "function") {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "td-refill-upsell",
                productVariantId: variantId,
                cartData: response,
              });
            }

            if (cart.classList.contains("is-empty"))
              cart.classList.remove("is-empty");
            cart.renderContents(response);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            addBtn.removeAttribute("disabled");
            setQty(1);
          });
      });
    }
  }

  function init() {
    document.querySelectorAll(".refill-bar").forEach(initBar);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
